module.exports = __webpack_public_path__ + "img/main_menu_6.735ca579.png";